<template>
  <div class="general-test-file">
    <drop-uploader
      ref="dropUploader"
      :action="URL.common.uploadStorage"
      :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
      :file-format="fileFormat"
      :close-on-click-modal="false"
      :multiple="false"
      @upload-result-file="uploadResult"
    />
    <cargo-left-right-resize
      style="width:100%;height: 80%;"
      :left-style="{'min-width': '550px',width:'50%'}"
      :right-style="{'min-width': '550px',width:'50%'}"
    >
      <template slot="left">
        <div>
          <span>{{ $t('CargoMsg.Cargo_FileName2') + (ocrTemplate.fileName || '') }}</span>
          <el-button type="primary" style="width: 110px;margin-left: 5px" no="uploadFile" @click="$refs.dropUploader.triggeFileSelectWindow()">{{ $t('SeaExport.UploadFile') }}</el-button>
        </div>
        <div style="width: 100%;height:95%;overflow: auto;border: 1px solid #cccccc;margin-top: 10px">
          <el-form
            label-position="left"
            label-width="0px"
            style="height: 100%"
          >
            <el-form-item label=" " style="height: 100%" class="input-from">
              <el-input v-model="promptTxt" class="input-border" :filter-chars="false" type="textarea" clearable />
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="right">
        <div style="height:26px;margin-top: 12px">
          <span>{{ $t('CargoMsg.Cargo_IdentifyReturnResult') }}</span>
        </div>
        <div style="border: 1px solid #cccccc;height: 95%">
          <div style="padding: 10px;height: 100%;overflow-y: auto;">
            <div v-if="ocrTemplate.resultJsonTableData && ocrTemplate.resultJsonTableData.length > 0 && ocrTemplate.resultJsonTableData[pageNum-1].length > 0" style="border: 1px solid black;height: auto">
              <div
                v-for="(pair, index) in ocrTemplate.resultJsonTableData[pageNum-1]"
                :key="index"
                class="list-style"
                style="width: 100%;display: flex"
              >
                <div
                  style="width: 50%;display: flex;"
                  @click="()=>{
                    curFocus = pair[0][0]
                    if(resultArray[pageNum-1].pointer) {
                      resultArray[pageNum-1].pointer.curFocus=pair[0][0]
                    }
                  }"
                >
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[0][0] }}</span></div>
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[0][1] }}</span></div>
                </div>
                <div
                  v-if="pair[1]"
                  style="width: 50%;display: flex;"
                  @click="()=>{
                    curFocus = pair[1][0]
                    if(resultArray[pageNum-1].pointer) {
                      resultArray[pageNum-1].pointer.curFocus=pair[1][0]
                    }
                  }"
                >
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[1][0] }}</span></div>
                  <div style="width: 50%;display: flex;border: 1px solid black;padding: 5px"><span style="align-self: center">{{ pair[1][1] }}</span></div>
                </div>
                <div
                  v-else
                  style="width: 50%;display: flex;"
                >
                  <div style="width: 100%;display: flex;border: 1px solid black;padding: 5px" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <div slot="footer" style="display: flex;justify-content: center">
      <div>
        <!--分页-->
        <el-pagination
          style="position: absolute;right: 200px"
          class="general-pagination"
          :current-page.sync="pageNum"
          :pager-count="5"
          :page-size="1"
          layout="prev, pager, next, jumper"
          :total="total"
        />
      </div>
      <div style="margin-top: 50px">
        <div style="display: inline-block">
          <el-button type="primary" no="1" style="margin-left: 5px;" @click="recognitionHandler"> {{ $t('CargoMsg.Cargo_Recognition') }} </el-button>
          <el-button type="primary" no="1" style="margin-left: 5px;" @click="refreshHandler()"> {{ $t('CargoMsg.Cargo_Refresh') }} </el-button>
          <el-button type="primary" no="1" style="margin-left: 5px;" @click="sampleHandler()"> {{ this.$t('CargoMsg.Cargo_PromptWords') + $t('CargoMsg.Cargo_Sample') }} </el-button>
        </div>
      </div>
    </div>

    <el-dialog
      v-el-drag-dialog
      :visible.sync="promptWordDialog.visible"
      :title="this.$t('CargoMsg.Cargo_PromptWords') + $t('CargoMsg.Cargo_Sample')"
      width="700px"
      :close-on-click-modal="true"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form style="margin-left: 50px">
          <el-form-item>
            <pre
              style="white-space: pre-wrap;overflow-y: auto;overflow-x: hidden;width: 600px;height:60vh;min-height: 300px;"
              v-html="promptWordDialog.promptWord"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="promptWordDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import URL from '@/api/urlTranslator'
import { OCR_CODE_HANDLE, OCR_DETAIL } from '@/class/cargo/model/parameters/SystemConstants'
import { ocrAnalyseByPromptFunc } from '@/api/ocrTemplate'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'GeneralTestFile',
  components: { CargoLeftRightResize, DropUploader },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      OCR_CODE_HANDLE, OCR_DETAIL,
      URL,
      promptWordDialog: {
        visible: false,
        promptWord: ''
      },
      ocrTemplate: {
        fileId: '', // 文件编号
        originResultJson: '',
        resultJson: '',
        fileName: '',
        resultJsonTableData: []
      },
      promptTxt: '',
      curFocus: '',
      fileFormat: '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif',
      pageNum: 1 // 当前页
    }
  },
  computed: {
    resultArray() {
      return this.ocrTemplate.resultJson ? (Array.isArray(JSON.parse(this.ocrTemplate.resultJson)) ? JSON.parse(this.ocrTemplate.resultJson) : null) : null
    },
    total() { // 总页数
      return this.ocrTemplate.resultJson ? (Array.isArray(JSON.parse(this.ocrTemplate.resultJson)) ? JSON.parse(this.ocrTemplate.resultJson).length : 0) : 0
    }
  },
  watch: {
    'ocrTemplate.resultJson': {
      immediate: true,
      async handler() {
        if (this.ocrTemplate.resultJson && Array.isArray(JSON.parse(this.ocrTemplate.resultJson))) {
          const resultJsonTableData = []
          for (const item of JSON.parse(this.ocrTemplate.resultJson)) {
            const objectArray = Object.entries(item.text.data)
            const formattedArray = []
            for (let i = 0; i < objectArray.length; i += 2) {
              formattedArray.push([objectArray[i], objectArray[i + 1]])
            }
            resultJsonTableData.push(formattedArray)
          }
          this.ocrTemplate.resultJsonTableData = resultJsonTableData
        }
      }
    }
  },
  methods: {
    refreshHandler() {
      this.promptTxt = ''
      this.ocrTemplate.fileId = ''
      this.ocrTemplate.fileName = ''
    },
    sampleHandler() {
      this.promptWordDialog.promptWord = this.$t('CargoMsg.Cargo_PromptWord')
      this.promptWordDialog.visible = true
    },
    recognitionHandler() {
      if (!this.promptTxt) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_PromptWords'))
        return
      }
      if (!this.ocrTemplate.fileId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseUploadFile'))
        return
      }
      const loading = getLoading()
      const params = {
        anyStr: this.promptTxt,
        anyStr1: this.ocrTemplate.fileId,
        anyStr2: this.ocrTemplate.fileName
      }
      this.ocrTemplate.resultJsonTableData = ''
      return ocrAnalyseByPromptFunc(params).then(res => {
        this.ocrTemplate.originResultJson = res.data.originResultJson
        this.ocrTemplate.resultJson = res.data.resultJson
      }).finally(() => {
        loading.close()
      })
    },
    uploadResult(res) {
      this.ocrTemplate.fileId = res.response.data
      this.ocrTemplate.fileName = res.name
    }
  }
}
</script>

<style lang="scss">
.general-test-file {
  padding-top: 20px;
  padding-left: 20px;
  background-color: white;

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 100%;
    }
  }

  .input-border {
    height: 100%;
    .el-textarea__inner{
      width: 100%;
      height: 100%;
    }
  }
  .general-pagination {
    .el-pager {
      li.number.active {
        color: blue !important;
      }
    }
  }
}

</style>
